import { Messages } from '../../../../codegen/Localize';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { GrantLicenseModes } from '../../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { deleteGroups } from '../../../actions/spaces/GroupMenuActions';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const GroupDeleteAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.DeleteGroup,
  translateName: Messages.deleteGroup_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    const targetItemsWithoutAllUsersGroup = targetItems.filter(group => !group.isAllUsersGroup);
    return targetItemsWithoutAllUsersGroup.length >= 1;
  },
  isClickable: (availableActions: {}, targetItems: IGroupInfo[], state: AppState) => SessionUserSelectors.canManageUsers(state) || hasGroupsWithoutLicenseUponLoginOnly(targetItems),
  createReduxAction: (targetItems: IGroupInfo[]) => deleteGroups(targetItems)
};

function hasGroupsWithoutLicenseUponLoginOnly(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => !group.grantLicenseMode || group.grantLicenseMode === GrantLicenseModes.ON_SYNC).length;
  return result === groups.length;
}